import './PaperlessAccordionWithFootNotes.scss';
import React, { Fragment, useState, useEffect } from 'react';

import { ReactComponent as CarrotDown } from 'assets/icons/chevron-down.svg';
import { usePrevious } from 'support/ReactUtils';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';

const PaperlessAccordionWithFootNotes = ({
  openTitle,
  closeTitle,
  id,
  body,
  headerNotes,
  requestStatus
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const previousRequestStatus = usePrevious(requestStatus && requestStatus.updateDocumentDelivery);

  useEffect(() => {
    if(previousRequestStatus === REQUEST_STATES.requested && requestStatus.updateDocumentDelivery && requestStatus.updateDocumentDelivery === REQUEST_STATES.received) {
      setIsOpen(false);
    }
  }, [requestStatus]);

  return (
    <div className="accordion" data-testid="accordion">
      <button
        aria-expanded={isOpen}
        className="accordion-button"
        data-testid="accordion-button"
        onClick={() => setIsOpen(!isOpen)}
        id={id}>
        <div className="accordion-title" data-testid="accordion-button-title">
          {isOpen ? closeTitle : openTitle}
        </div>
        <CarrotDown className={`${isOpen && 'arrow-up'} toggle-carrot-icon`} />
      </button>
      {headerNotes && <Fragment>{headerNotes}</Fragment>}
      {isOpen && <div className="accordion-body">{body}</div>}
    </div>
  );
};

export default PaperlessAccordionWithFootNotes;
